import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import recommendKeyword from 'api/axios/foka/recommendKeyword'
import api from 'api/axios/foka'

const initialState = {
  keyword: '',
  isLoading: false,
  content: [],
  registered: [],
  selected: [],
}

export const fetchProposalKeywords = createAxiosThunk(
  'keywordPlanner/fetchProposalKeywords',
  async (noArgs, { getState }) => {
    const { keyword } = getState().keywordPlanner.proposalKeyword
    const {
      data: { data },
    } = await recommendKeyword.searchKeywords(keyword)
    const texts = data.map(item => item.keyword)
    const {
      data: { content },
    } = await recommendKeyword.getRegisteredKeywords(texts)
    return api.response({
      content: data,
      registered: content,
    })
  }
)

const proposalKeywordSlice = createSlice({
  name: 'keywordPlanner/proposalKeyword',
  initialState,

  reducers: {
    setKeyword: (state, { payload }) => {
      state.keyword = payload
    },
    setSelected: (state, { payload }) => {
      const index = state.selected.indexOf(payload)
      if (index !== -1) {
        state.selected.splice(index, 1)
      } else {
        state.selected.push(payload)
      }
    },
    selectAll: state => {
      state.selected = state.content.map(({ keyword }) => keyword)
    },
    clearSelected: state => {
      state.selected = []
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchProposalKeywords.pending, state => {
      state.isLoading = true
    })

    builder.addCase(
      fetchProposalKeywords.fulfilled,
      (state, { payload: { content, registered } }) => {
        state.content = content
        state.registered = registered
        state.isLoading = false
      }
    )

    builder.addCase(fetchProposalKeywords.rejected, state => {
      state.isLoading = false
    })
  },
})
const { actions, reducer } = proposalKeywordSlice
export const { setKeyword, setSelected, selectAll, clearSelected, reset } =
  actions
export default reducer
